<ng-container *ngIf="paymentMethodType$ | async as paymentMethodType">
  <h2 class="mb-3">
    {{
      (paymentMethodType === 'CREDIT_CARD'
        ? 'commercialCommon.paymentMethodWithData.enterCreditCard'
        : 'commercialCommon.paymentMethodWithData.enterBankAccount'
      ) | transloco
    }}
  </h2>

  <yat-credit-card-form
    *ngIf="paymentMethodType === 'CREDIT_CARD'"
    [input]="getEditableCreditCard(editablePaymentMethod$ | async)"
    (save)="save($event)"
    (cancelMethod)="cancel()"
    [validationError]="validationError"
    buttonsClassName="btn-large">
  </yat-credit-card-form>

  <yat-direct-debit-form
    *ngIf="paymentMethodType === 'DIRECT_DEBIT'"
    [input]="getEditableDirectDebit(editablePaymentMethod$ | async)"
    (save)="save($event)"
    (cancelMethod)="cancel()"
    buttonsClassName="btn-large">
  </yat-direct-debit-form>
</ng-container>
